import type {
  PartnerMetadataStateBookingPanel,
  PartnerMetadataTrustLevelBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/partnerMetadataBookingPanel';

export const get = (
  state: PartnerMetadataStateBookingPanel,
  id: string,
): PartnerMetadataTrustLevelBookingPanel => state.byId[id];
export const getAll = (
  state: PartnerMetadataStateBookingPanel,
): Record<string, PartnerMetadataTrustLevelBookingPanel> => state.byId;
